import classNames from 'classnames';

export const UpgradeImage = ({
  className,
  imagePath,
}: {
  className: string;
  imagePath: string;
}) => (
  <div
    className={classNames(
      'vai-bg-cover vai-bg-center vai-rounded-lg',
      className,
    )}
    style={{ backgroundImage: `url('${imagePath}')` }}
  />
);
